'use client'
import styled from 'styled-components'

const StyledImage = styled.img`
  height: 150px;
  width: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const LoaderImg = ({ src, alt }: { src: string; alt: string }) => {
  return <StyledImage src={src} alt={alt} />
}

export default LoaderImg
